import { render, staticRenderFns } from "./ApprovalsList.vue?vue&type=template&id=7205e3dc&"
import script from "./ApprovalsList.vue?vue&type=script&lang=ts&"
export * from "./ApprovalsList.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalsList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports